import seoConfig from "@/data/seo.config";
import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

const SeoHelmet = (props) => {
  return (
    <HelmetProvider>
      <Helmet>
        {/* Basic SEO */}
        <title>{props.title || seoConfig.default.title}</title>
        <meta name="description" content={props.description || seoConfig.default.description} />
        <meta name="keywords" content={props.keywords || seoConfig.default.keywords} />
        <meta name="author" content={props.author || seoConfig.default.author} />
      </Helmet>
    </HelmetProvider>

  );
}

export default SeoHelmet;
